module.exports = __webpack_public_path__ + "img/plancha.14248f8f.svg";